(function() {
  'use strict';

  // Session key to prevent showing multiple times
  const SESSION_KEY = 'notification_prompt_shown_session';
  const DELAY_MS = 3000; // 3 seconds
  const DISMISS_KEY = 'sm_notif_prompt_dismissed_at'; // kept for analytics; no longer gates the prompt
  // Topic preferences: absent key or [] = everything
  const TOPIC_KEY = 'sm_push_topics';
  const TOPICS = [
    { slug: 'lawn-suits', label: 'Lawn Suits' },
    { slug: 'kurta-sets', label: 'Kurta Sets' },
    { slug: 'lehenga-choli', label: 'Lehenga Choli' },
    { slug: 'sharara-gharara', label: 'Sharara & Gharara' },
    { slug: 'sarees', label: 'Sarees' },
    { slug: 'bridal-suits', label: 'Bridal Suits' },
    { slug: 'footwear-jewellery', label: 'Footwear & Jewellery Sets' }
  ];

  function getTopicsRaw() {
    try { return localStorage.getItem(TOPIC_KEY) || ''; } catch (e) { return ''; }
  }

  function showTopicPicker() {
    const card = document.getElementById('pwaTopicPicker');
    const list = document.getElementById('pwaTopicList');
    if (!card || !list) return;
    let chosen = [];
    try { chosen = JSON.parse(getTopicsRaw() || '[]'); } catch (e) { chosen = []; }
    if (!Array.isArray(chosen)) chosen = [];
    list.innerHTML = '';
    for (const t of TOPICS) {
      const row = document.createElement('label');
      row.className = 'pwa-topic-item';
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.value = t.slug;
      cb.checked = !chosen.length || chosen.includes(t.slug);
      const span = document.createElement('span');
      span.textContent = t.label;
      row.appendChild(cb);
      row.appendChild(span);
      list.appendChild(row);
    }
    setTimeout(() => card.classList.add('show'), 100);
  }
  window.SMOpenNotifPrefs = showTopicPicker;

  window.saveTopicPrefs = function(everything) {
    const card = document.getElementById('pwaTopicPicker');
    const boxes = document.querySelectorAll('#pwaTopicList input[type=checkbox]');
    let chosen = [];
    if (!everything) {
      boxes.forEach(b => { if (b.checked) chosen.push(b.value); });
    }
    // all ticked (or none — don't starve them) = everything, stored as []
    if (everything || !chosen.length || chosen.length === TOPICS.length) chosen = [];
    try { localStorage.setItem(TOPIC_KEY, JSON.stringify(chosen)); } catch (e) {}
    if (card) card.classList.remove('show');
    subscribeAndSync().catch(function(e) { console.log('[Push] topic sync failed', e); });
    if (typeof gtag !== 'undefined') gtag('event', 'push_topics_saved', { count: chosen.length || TOPICS.length });
  };
  
  // Check if we should show the prompt
  function shouldShowPrompt() {
    // 1. Check if running as PWA
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  window.navigator.standalone === true;
    
    if (!isPWA) {
      console.log('[NotificationPrompt] Not running as PWA, skipping');
      return false;
    }

    // 2. Check if Notification API is supported
    if (!('Notification' in window)) {
      console.log('[NotificationPrompt] Notifications not supported');
      return false;
    }

    // 3. Check current permission status
    if (Notification.permission === 'granted') {
      console.log('[NotificationPrompt] Notifications already granted');
      return false;
    }

    if (Notification.permission === 'denied') {
      console.log('[NotificationPrompt] Notifications denied by user');
      return false;
    }

    // 4. Check if already shown in this session
    if (sessionStorage.getItem(SESSION_KEY)) {
      console.log('[NotificationPrompt] Already shown in this session');
      return false;
    }

    // "Not Now" no longer applies a multi-day cooldown — the prompt returns on
    // every new app session (owner decision 2026-07-12); once-per-session guard above still applies

    // All checks passed
    return true;
  }

  // Show the prompt
  function showPrompt() {
    const prompt = document.getElementById('pwaNotificationPrompt');
    if (!prompt) return;

    console.log('[NotificationPrompt] Showing prompt');
    
    // Mark as shown for this session
    sessionStorage.setItem(SESSION_KEY, 'true');
    
    // Show with animation
    setTimeout(() => {
      prompt.classList.add('show');
    }, 100);
  }

  // Hide the prompt
  function hidePrompt() {
    const prompt = document.getElementById('pwaNotificationPrompt');
    if (!prompt) return;

    prompt.classList.remove('show');
  }

  // Dismiss prompt (user clicked "Not Now")
  window.dismissNotificationPrompt = function() {
    console.log('[NotificationPrompt] User dismissed');
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
    hidePrompt();
  };

  // ============ REAL WEB PUSH (PWA Phase 2, 2026-07-03) ============
  const VAPID_PUBLIC_KEY = 'BPe2ILffFKbzo7xQbe2Ex4VctE99emFm4i0UBCrUvNcsSwRVy3pKW-WQzFLjqDWWrA1H60VR94qPPKO3g59BZpA';
  const SUBSCRIBE_ENDPOINT = 'https://n8n-shaf-u71178.vm.elestio.app/webhook/push-subscribe';
  const SYNC_MARKER = 'sm_push_synced_at';
  const SYNC_SIG = 'sm_push_sig'; // cartToken|customerEmail|rawWishlist at last sync — resync on change
  // Logged-in customer (empty when browsing as guest) — lets us identify subscribers by account
  const CUST_EMAIL = (window.SM_CUSTOMER && window.SM_CUSTOMER.email) || '';
  const CUST_NAME = (window.SM_CUSTOMER && window.SM_CUSTOMER.name) || '';

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
  }

  async function getSWRegistration() {
    if (!('serviceWorker' in navigator)) return null;
    for (let i = 0; i < 10; i++) {
      const regs = await navigator.serviceWorker.getRegistrations();
      if (regs.length && regs[0].active) return regs[0];
      if (regs.length && i > 4) return regs[0];
      await new Promise(r => setTimeout(r, 500));
    }
    return null;
  }

  // Cart token (same source as sm-cart-tracker: /cart.js) + wishlist (same key as wishlist.js)
  async function collectContext() {
    let cartToken = '';
    try {
      const c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
      cartToken = String(c.token || '').split('?')[0];
    } catch (e) { /* cart unavailable — sync without it */ }
    let raw = '[]';
    let wishlist = [];
    try {
      raw = localStorage.getItem('shopify_wishlist') || '[]';
      wishlist = JSON.parse(raw);
      if (!Array.isArray(wishlist)) { wishlist = []; raw = '[]'; }
    } catch (e) { wishlist = []; raw = '[]'; }
    const topicsRaw = getTopicsRaw();
    let topics;
    try { topics = topicsRaw ? JSON.parse(topicsRaw) : undefined; } catch (e) { topics = undefined; }
    if (topics !== undefined && !Array.isArray(topics)) topics = undefined;
    return { cartToken: cartToken, wishlist: wishlist.slice(0, 150), raw: raw, topicsRaw: topicsRaw, topics: topics };
  }

  async function subscribeAndSync() {
    const reg = await getSWRegistration();
    if (!reg) { console.log('[Push] No service worker registration found'); return null; }
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      });
    }
    const ctx = await collectContext();
    await fetch(SUBSCRIBE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'sync',
        subscription: sub.toJSON(),
        ua: navigator.userAgent,
        cartToken: ctx.cartToken,
        wishlist: ctx.wishlist,
        customerEmail: CUST_EMAIL,
        customerName: CUST_NAME,
        topics: ctx.topics
      })
    });
    localStorage.setItem(SYNC_MARKER, String(Date.now()));
    try { localStorage.setItem(SYNC_SIG, ctx.cartToken + '|' + CUST_EMAIL + '|' + ctx.topicsRaw + '|' + ctx.raw); } catch (e) {}
    console.log('[Push] Subscribed & synced to server (cart + wishlist)');
    return { reg: reg, sub: sub };
  }

  // Enable notifications (user clicked "Enable") — real subscription now
  window.enableNotifications = async function() {
    console.log('[NotificationPrompt] User clicked enable');
    hidePrompt();

    try {
      const permission = await Notification.requestPermission();
      console.log('[NotificationPrompt] Permission result:', permission);
      if (permission !== 'granted') return;

      const result = await subscribeAndSync();
      if (result && result.reg) {
        // NOTE: must use SW showNotification — `new Notification()` throws on Android Chrome
        result.reg.showNotification('Notifications Enabled!', {
          body: "You'll be first to know about new arrivals and exclusive deals.",
          icon: 'https://cdn.shopify.com/s/files/1/0575/3199/0109/files/salwar-mahal-app-icon-512.png?v=1783052316&width=192&height=192',
          tag: 'welcome'
        });
      }
      if (typeof gtag !== 'undefined') gtag('event', 'push_subscribed');
      // Follow up: let them choose which product types to hear about
      setTimeout(showTopicPicker, 1200);
    } catch (error) {
      console.error('[NotificationPrompt] Error enabling push:', error);
    }
  };

  // Initialize
  function init() {
    console.log('[NotificationPrompt] Initializing...');

    // Heal: permission already granted -> keep server copy of subscription + cart/wishlist fresh.
    // Re-sync when 4h have passed, the wishlist changed, or we've never synced context.
    if ('Notification' in window && Notification.permission === 'granted' && 'serviceWorker' in navigator) {
      const last = localStorage.getItem(SYNC_MARKER);
      const stale = !last || (Date.now() - Number(last)) > 4 * 60 * 60 * 1000;
      let wlChanged = false;
      const sig = localStorage.getItem(SYNC_SIG);
      if (!sig) {
        wlChanged = true; // pre-context install — sync once to capture cart/wishlist
      } else {
        try {
          const rawNow = localStorage.getItem('shopify_wishlist') || '[]';
          const parts = sig.split('|');
          // sig = cart|email|topics|wishlist; older shorter sigs mismatch once, forcing one resync
          wlChanged = parts.slice(3).join('|') !== rawNow || parts[1] !== CUST_EMAIL || (parts[2] || '') !== getTopicsRaw();
        } catch (e) {}
      }
      if (stale || wlChanged) {
        subscribeAndSync().catch(function(e) { console.log('[Push] resync failed', e); });
      }
    }
    console.log('[NotificationPrompt] Current permission:', Notification.permission);

    if (shouldShowPrompt()) {
      console.log('[NotificationPrompt] Will show in', DELAY_MS, 'ms');
      setTimeout(showPrompt, DELAY_MS);
    } else {
      console.log('[NotificationPrompt] Conditions not met, not showing');
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
